<template>
  <div
    class="bg-white h-full container-with-transition"
    :style="{ minHeight: `${height + 50}px` }"
  >
    <div
      v-if="false"
      class="flex items-center justify-center h-[400px] bg-white"
    >
      <div class="text-center">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#F95031] mx-auto mb-2" />
      </div>
    </div>

    <iframe
      v-show="!isInitialLoading"
      ref="bundlingVariantEditIframe"
      class="iframe-with-transition"
      frameborder="1"
      :style="{ height: `${height + 50}px` }"
      width="100%"
      :src="iframeSrc"
      allow="clipboard-read; clipboard-write"
      @load="handleIframeLoad"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: 400,
      isInitialLoading: true,
    }
  },
  computed: {
    iframeSrc() {
      return `${process.env.VUE_APP_BASE_AUTH_MODULE}/product/bundle-variant/${this.$route.params.product_id}/edit`
    },
  },
  mounted() {
    window.addEventListener('message', this.watchIframe)
  },
  destroyed() {
    window.removeEventListener('message', this.watchIframe)
  },
  methods: {
    /**
         * Handle the iframe message event
         * @param {Object} event - the iframe message event
         */
    async watchIframe(event) {
      if (event.origin !== process.env.VUE_APP_BASE_AUTH_MODULE) return

      const {
        type,
        data,
      } = event.data

      if (type === 'ERROR_MESSAGE') {
        this.$toast_error({
          message: data.message,
        })

        return
      }

      if (type === 'BUNDLING_VARIANT_UPDATED') {
        this.$toast_success({
          message: 'Produk bundling variant berhasil diubah',
        })

        this.$router.push({
          name: 'data-produk',
        })

        return
      }

      if (type === 'GO_BACK') {
        this.$router.go(-1)

        return
      }

      if (type === 'SET_DIMENSION' && data.height > 400) {
        this.height = Math.floor(data.height)
      }
    },
    /**
         * Handle the iframe load event
         */
    handleIframeLoad() {
      this.isInitialLoading = false
    },
    /**
         * Handle routing user back to the previous page
         */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'search-gudang' })
      }
    },
  },
}
</script>

<style scoped>
  .container-with-transition {
    transition: min-height 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .iframe-with-transition {
    transition: height 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  }

  @media (prefers-reduced-motion: reduce) {

    .container-with-transition,
    .iframe-with-transition {
      transition: none;
    }
  }
</style>
